<template>
  <div class="max-w-[2560px] mx-auto">
    <div>
      <navigation-bar :hasNoBg="true"></navigation-bar>
    </div>
    <div>
      <get-in-touch></get-in-touch>
    </div>
    <div>
      <send-mail-component></send-mail-component>
    </div>
    <div>
      <footer-view></footer-view>
    </div>
  </div>
</template>

<script>
import NavigationBar from "@/view/NavigationBar.vue";
import getInTouch from "@/components/ContactUsComponent/getInTouch.vue";
import sendMailComponent from "@/components/ContactUsComponent/sendMailComponent.vue";
import FooterView from "./footerView.vue";
export default {
  components: {
    NavigationBar,
    getInTouch,
    FooterView,
    sendMailComponent,
  },
  data() {
    return {};
  },
};
</script>

<style></style>
